import {
  openFileupload,
  showFileuploadAccessError,
  getFileuploadDisplayName,
} from "@/utils/fileuploadAccess";

export default {
  methods: {
    normalizePaymentRequestFileList(raw) {
      if (!raw) return [];
      const list = Array.isArray(raw) ? raw : [raw];
      return list.filter((f) => f != null && f !== "");
    },
    getReceiptFileLabel(file) {
      const ref = typeof file === "string" ? file : file?.url;
      const name = getFileuploadDisplayName(ref || "");
      return name || this.$t("Receipt");
    },
    getReceiptFiles(payment) {
      const seen = new Set();
      const out = [];
      const add = (f) => {
        if (!f) return;
        let key;
        if (typeof f === "string") key = f;
        else if (f && typeof f === "object" && f.url) key = f.url;
        else {
          try {
            key = JSON.stringify(f);
          } catch {
            key = String(f);
          }
        }
        if (seen.has(key)) return;
        seen.add(key);
        out.push(f);
      };

      const raw = payment && payment.payment_request_file;
      if (Array.isArray(raw)) {
        raw.forEach((f) => add(f));
      } else {
        add(raw);
      }

      return out;
    },
    async openReceipt(file) {
      if (!file) return;
      const ref = typeof file === "string" ? file : file?.url;
      if (!ref) return;
      const result = await openFileupload(ref, { t: (k) => this.$t(k) });
      if (!result.ok) {
        showFileuploadAccessError(this, result.errorMessage, {
          title: this.$t("Error accessing receipt file"),
          fileRef: ref,
        });
      }
    },
  },
};
